/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

export const APP_EVENTS = {
  TOAST: 'Toast',
  LIBRARY_LOADED: 'LibraryLoaded',
  PLUGIN_LOADED: 'PluginLoaded',
  PLUGIN_UNLOADED: 'PluginUnloaded',
  LOCALE_SET: 'LocaleSet',
  SEARCH_UPDATED: 'SearchUpdated',
  ON_ACTION: 'OnAction',
};

export const PLUGIN_EVENTS = {
  TOAST: 'Toast',
  SHOW_LOADER: 'ShowLoader',
  HIDE_LOADER: 'HideLoader',
};
